import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { X, QrCode } from 'lucide-react';
import { useGetProvisioningConfigQuery } from '../../services/baseUnitApi';

interface Props {
  onClose: () => void;
}

export default function ProvisioningQRModal({ onClose }: Props) {
  const { data, isLoading, error } = useGetProvisioningConfigQuery();

  const qrPayload = data
    ? JSON.stringify({ v: 1, b: data.broker, p: data.port, u: data.username, pw: data.password, c: data.customer_id })
    : null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60">
      <div className="bg-app-panel dark:bg-gray-900 rounded-xl shadow-2xl w-full max-w-sm">
        <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700">
          <div className="flex items-center gap-2">
            <QrCode className="h-5 w-5 text-indigo-500" />
            <h2 className="text-base font-semibold text-gray-900 dark:text-white">Device Setup QR</h2>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
            aria-label="Close"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="p-6 flex flex-col items-center gap-4">
          {isLoading && (
            <div className="h-48 flex items-center justify-center">
              <div className="h-8 w-8 rounded-full border-2 border-gray-300 border-t-indigo-500 animate-spin" />
            </div>
          )}

          {error && (
            <p className="text-sm text-red-600 dark:text-red-400 text-center">
              Failed to load provisioning config. Please try again.
            </p>
          )}

          {qrPayload && (
            <>
              <div className="p-3 bg-white rounded-lg shadow-sm">
                <QRCodeSVG value={qrPayload} size={200} level="M" />
              </div>

              <div className="text-center space-y-1">
                <p className="text-xs text-gray-500 dark:text-gray-400">Customer ID</p>
                <p className="text-sm font-semibold text-gray-900 dark:text-white font-mono">{data.customer_id}</p>
              </div>

              <div className="w-full bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-100 dark:border-indigo-800/60 rounded-lg p-3">
                <p className="text-xs text-indigo-700 dark:text-indigo-300 text-center leading-relaxed">
                  Open the TS1 Portal app → Add Device → tap <strong>Scan QR Code</strong>
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
